import React, { FormEvent, useEffect, useRef, useState } from 'react'
import { Head } from '@components'
import * as st from '@assets/styl/referralCampaign.module.styl'
import { useLanguage } from '../hooks'
import { graphql, navigate, useStaticQuery } from 'gatsby'
import { translatePath } from '../translations'
import cn from 'classnames'
import axios from 'axios'
import InputMask from 'react-input-mask'
import { useGSAP } from '@gsap/react'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'

import prizes from '@assets/img/prizes.png'
import lancamentosCampapanha from '@assets/img/lancamentos-campanha.jpg'
import dimas from '@assets/svg/dimas-campanha.svg'
import facebook from '@assets/svg/facebook.svg'
import instagram from '@assets/svg/instagram.svg'
import linkedin from '@assets/svg/linkedin.svg'
import youtube from '@assets/svg/youtube.svg'
import { Link } from 'react-scroll'
import { useTrafficSource } from '../hooks/useTrafficSource'

const ReferralCampaign = () => {
  const { t } = useLanguage()
  const dataApi = useStaticQuery(graphql`
    query {
      allConfigurations {
        nodes {
          phone
          facebook
          instagram
          linkedin
          youtube
        }
      }
    }
  `)
  const socials = dataApi.allConfigurations.nodes[0]
  const [client, setClient] = useState(false)
  const [breakpoint, setBreakpoint] = useState('')
  const [submitLabel, setSubmitLabel] = useState(t('ReferralCampaign.send'))
  const defaultData = {
    cf_nome_do_amigo: '',
    email: '',
    cf_telefone_do_indicado: '',
    nome: '',
    cf_cpf: '',
    cf_empreendimento: '',
    permissao: false,
    identificador: 'LP Campanha de Indicação',
  }
  const [data, setData] = useState({ ...defaultData })

  const sectionLead = useRef(null)
  const sectionPrizes = useRef(null)
  const sectionEnterprises = useRef(null)

  const animationForm = useRef(null)
  const animationText = useRef(null)
  const sectionPrizesImage = useRef(null)
  const sectionPrizesText = useRef(null)
  const sectionEnterprisesText = useRef(null)
  const sectionEnterprisesImage = useRef(null)
  const trafficSource = useTrafficSource()

  const onSubmit = (
    e: FormEvent,
    data: any,
    loadingHandler: () => void,
    successHandler: () => void
  ) => {
    e.preventDefault()
    data.token_rdstation = '529cac2f361142d6e1232668a5dbe8f9'
    data.traffic_source = trafficSource
    loadingHandler()
    axios
      .post('https://www.rdstation.com.br/api/1.3/conversions', data, {
        headers: {
          'Content-type': 'application/json',
        },
      })
      .then((data) => {
        loadingHandler()
        data.status === 200 && navigate('/sucesso-campanha/')
        successHandler()
      })
  }

  useEffect(() => {
    const getBreakpoint = () => {
      if (matchMedia('(max-width: 600px)').matches) setBreakpoint('mobile')
      else if (matchMedia('(max-width: 1024px)').matches)
        setBreakpoint('tablet')
      else setBreakpoint('desktop')
    }

    getBreakpoint()

    window.addEventListener('resize', getBreakpoint)
    return () => window.removeEventListener('resize', getBreakpoint)
  }, [])

  useGSAP(() => {
    gsap.registerPlugin(ScrollTrigger)
    const mm = gsap.matchMedia()

    mm.add('(min-width: 599px)', () => {
      gsap.fromTo(
        animationForm.current,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          scrollTrigger: {
            trigger: sectionLead.current,
            start: 'top center',
          },
        }
      )
      gsap.fromTo(
        animationText.current,
        {
          x: '-100%',
        },
        {
          x: 0,
          scrollTrigger: {
            trigger: sectionLead.current,
            start: 'top center',
          },
        }
      )
      gsap.fromTo(
        sectionPrizesImage.current,
        {
          x: '-150%',
        },
        {
          x: 0,
          scrollTrigger: {
            trigger: sectionPrizes.current,
            start: 'top center',
          },
        }
      )
      gsap.fromTo(
        sectionPrizesText.current,
        {
          x: '150%',
        },
        {
          x: 0,
          scrollTrigger: {
            trigger: sectionPrizes.current,
            start: 'top center',
          },
        }
      )
      gsap.fromTo(
        sectionEnterprisesText.current,
        {
          x: '-150%',
        },
        {
          x: 0,
          scrollTrigger: {
            trigger: sectionEnterprises.current,
            start: 'top center',
          },
        }
      )
      gsap.fromTo(
        sectionEnterprisesImage.current,
        {
          x: '150%',
        },
        {
          x: 0,
          scrollTrigger: {
            trigger: sectionEnterprises.current,
            start: 'top center',
          },
        }
      )
    })
  }, [])

  return (
    <>
      <Head
        pathname={translatePath('/campanha-de-indicacao/')}
        title={t('ReferralCampaign.titlePage')}
        description={t('ReferralCampaign.description')}
      />
      <div className={st.intro}>
        <section className={st.content}>
          <h1>
            {t('ReferralCampaign.title.1')}
            <br />
            {t('ReferralCampaign.title.2')}
          </h1>
          <p>
            {t('ReferralCampaign.subtitle.1')}{' '}
            {breakpoint !== 'desktop' ? null : <br />}
            {t('ReferralCampaign.subtitle.2')}{' '}
            <span>{t('ReferralCampaign.subtitle.span1')}</span>{' '}
            {t('ReferralCampaign.subtitle.3')}{' '}
            <span>{t('ReferralCampaign.subtitle.span2')}</span>
          </p>
          <Link
            to="lead"
            smooth={true}
            duration={500}
            className={cn('btn', st.regulation)}
          >
            {t('ReferralCampaign.regulation')}
          </Link>
        </section>
      </div>
      <div className={st.lead} ref={sectionLead} id="lead">
        <div className={st.content}>
          <div className={st.text}>
            <p ref={animationText}>
              {t('ReferralCampaign.leadText.1')} <br />
              <br />
              {t('ReferralCampaign.leadText.2')} <br />
              <br />
              {t('ReferralCampaign.leadText.3')} {''}
              {t('ReferralCampaign.leadText.4')}
            </p>
          </div>
          <div className={st.formContainer} ref={animationForm}>
            <div className={st.option}>
              <button
                type="button"
                className={cn(st.btnPage, { [st.activeOption]: client })}
                onClick={() => setClient(false)}
              >
                {t('ReferralCampaign.optionButton.1')}
              </button>
              <button
                type="button"
                className={cn(st.btnPage, { [st.activeOption]: !client })}
                onClick={() => setClient(true)}
              >
                {t('ReferralCampaign.optionButton.2')}
              </button>
            </div>
            {!client && (
              <form
                onSubmit={(e) =>
                  onSubmit(
                    e,
                    data,
                    () =>
                      setSubmitLabel(
                        submitLabel !== t('ReferralCampaign.send')
                          ? t('ReferralCampaign.send')
                          : t('ReferralCampaign.loading')
                      ),
                    () => setData({ ...defaultData })
                  )
                }
              >
                <div className={st.formGroup}>
                  <label htmlFor="friendName">
                    {t('ReferralCampaign.form.label1')}
                  </label>
                  <input
                    name="cf_nome_do_amigo"
                    type="text"
                    placeholder={t('ReferralCampaign.form.label1')}
                    id="friendName"
                    value={data.cf_nome_do_amigo}
                    onChange={(e) =>
                      setData({ ...data, cf_nome_do_amigo: e.target.value })
                    }
                    required
                  />
                </div>
                <div className={st.formGroup}>
                  <label htmlFor="friendEmail">
                    {t('ReferralCampaign.form.label2')}
                  </label>
                  <input
                    name="cf_e_mail_do_amigo"
                    type="email"
                    placeholder={t('ReferralCampaign.form.label2')}
                    id="friendEmail"
                    value={data.email}
                    onChange={(e) =>
                      setData({ ...data, email: e.target.value })
                    }
                    required
                  />
                </div>
                <div className={st.formGroup}>
                  <label htmlFor="friendPhone">
                    {t('ReferralCampaign.form.label3')}
                  </label>
                  <InputMask
                    mask={
                      data.cf_telefone_do_indicado.length > 14
                        ? '(99) 99999-9999'
                        : '(99) 9999-99999'
                    }
                    maskChar={null}
                    type="tel"
                    id="friendPhone"
                    placeholder={t('ReferralCampaign.form.label3')}
                    value={data.cf_telefone_do_indicado}
                    onChange={(e: { target: { value: any } }) =>
                      setData({
                        ...data,
                        cf_telefone_do_indicado: e.target.value,
                      })
                    }
                    required
                    pattern=".{14,15}"
                  />
                </div>
                <div className={st.formGroup}>
                  <label htmlFor="name">
                    {t('ReferralCampaign.form.label4')}
                  </label>
                  <input
                    type="text"
                    name="nome"
                    placeholder={t('ReferralCampaign.form.label4')}
                    id="name"
                    value={data.nome}
                    onChange={(e) => setData({ ...data, nome: e.target.value })}
                    required
                  />
                </div>
                <div className={st.formGroup}>
                  <label htmlFor="cpf">
                    {t('ReferralCampaign.form.label5')}
                  </label>
                  <InputMask
                    mask="999.999.999-99"
                    maskChar={null}
                    type="text"
                    id="cpf"
                    placeholder={t('ReferralCampaign.form.label5')}
                    value={data.cf_cpf}
                    onChange={(e: { target: { value: any } }) =>
                      setData({ ...data, cf_cpf: e.target.value })
                    }
                    required
                  />
                </div>
                <div className={st.formGroup}>
                  <label htmlFor="enterprise">
                    {t('ReferralCampaign.form.label6')}
                  </label>
                  <select
                    name="cf_empreendimento"
                    id="enterprise"
                    value={data.cf_empreendimento}
                    onChange={(e) =>
                      setData({ ...data, cf_empreendimento: e.target.value })
                    }
                    required
                  >
                    <option value="">Qual empreendimento?</option>
                    <option value={t('ReferralCampaign.form.optionsLabel6.1')}>
                      {t('ReferralCampaign.form.optionsLabel6.1')}
                    </option>
                    <option value={t('ReferralCampaign.form.optionsLabel6.2')}>
                      {t('ReferralCampaign.form.optionsLabel6.2')}
                    </option>
                    <option value={t('ReferralCampaign.form.optionsLabel6.3')}>
                      {t('ReferralCampaign.form.optionsLabel6.3')}
                    </option>
                    <option value={t('ReferralCampaign.form.optionsLabel6.4')}>
                      {t('ReferralCampaign.form.optionsLabel6.4')}
                    </option>
                    <option value={t('ReferralCampaign.form.optionsLabel6.5')}>
                      {t('ReferralCampaign.form.optionsLabel6.5')}
                    </option>
                    <option value={t('ReferralCampaign.form.optionsLabel6.6')}>
                      {t('ReferralCampaign.form.optionsLabel6.6')}
                    </option>
                  </select>
                </div>
                <div className={st.checkbox}>
                  <div className={cn(data.permissao && st.checked)}>
                    <input
                      type="checkbox"
                      id="permission"
                      checked={data.permissao}
                      onChange={(e) =>
                        setData({ ...data, permissao: e.target.checked })
                      }
                      required
                    />
                  </div>
                  <label htmlFor="permission">
                    <p>
                      {t('ReferralCampaign.permission.1')}{' '}
                      <a
                        target="_blank"
                        href="https://www.dimasconstrucoes.com.br/termos-de-uso/"
                      >
                        {t('ReferralCampaign.permission.2')}
                      </a>
                      <a
                        target="_blank"
                        href="https://www.dimasconstrucoes.com.br/politica-de-privacidade/"
                      >
                        {' '}
                        {t('ReferralCampaign.permission.3')}
                      </a>
                    </p>
                  </label>
                </div>
                <div className={st.submit}>
                  <button className={st.btnPage} type="submit">
                    {submitLabel}
                  </button>
                </div>
              </form>
            )}
            {client && (
              <div className={st.login}>
                <p>{t('ReferralCampaign.loginText')}</p>
                <a
                  className={cn(st.btnPage)}
                  href="https://app.winker.com.br/intra/default/login?wl=dimas"
                  target="_blank"
                >
                  {t('ReferralCampaign.loginBtn')}
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className={st.prizes} ref={sectionPrizes}>
        <section>
          <h2 ref={sectionPrizesText}>
            {t('ReferralCampaign.prizesText.1')}
            <span>{t('ReferralCampaign.prizesText.span1')}</span>
            {t('ReferralCampaign.prizesText.2')}{' '}
            <span>{t('ReferralCampaign.prizesText.span2')} </span>
            {t('ReferralCampaign.prizesText.3')}{' '}
            <span>{t('ReferralCampaign.prizesText.span3')}</span>{' '}
            {t('ReferralCampaign.prizesText.4')}{' '}
            <span>{t('ReferralCampaign.prizesText.span4')}</span>{' '}
            {t('ReferralCampaign.prizesText.5')}
          </h2>
          <div ref={sectionPrizesImage}>
            <img
              src={prizes}
              alt={t('ReferralCampaign.prizesText.altImage')}
              width={651}
              height={461}
            />
          </div>
        </section>
      </div>
      <div className={st.enterprises} ref={sectionEnterprises}>
        <div className={st.content}>
          <section ref={sectionEnterprisesText}>
            <h2>{t('ReferralCampaign.enterprisesTitle')}</h2>
            <p>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('ReferralCampaign.enterprisesText.1'),
                }}
              ></p>
              {t('ReferralCampaign.enterprisesText.2')}{' '}
              <span>{t('ReferralCampaign.enterprisesText.span1')}</span>{' '}
              {t('ReferralCampaign.enterprisesText.3')}{' '}
              <span>{t('ReferralCampaign.enterprisesText.span2')}</span>{' '}
              {t('ReferralCampaign.enterprisesText.4')}
            </p>
            <a
              className={st.btnPage}
              href="https://www.dimasconstrucoes.com.br/empreendimentos/lancamentos/"
            >
              {t('ReferralCampaign.enterprisesBtn')}
            </a>
          </section>
          <div ref={sectionEnterprisesImage}>
            <img
              src={lancamentosCampapanha}
              alt={t('ReferralCampaign.enterprisesAltImage')}
              width={683}
              height={1105}
            />
          </div>
        </div>
      </div>
      <footer>
        <div className={st.content}>
          <img
            src={dimas}
            alt={t('ReferralCampaign.footerAltImage')}
            width={193}
            height={187}
          />
          <ul>
            <li>
              <a href={socials.youtube} target="_blank">
                <img
                  src={youtube}
                  alt="Youtube da Dimas construções"
                  width={39}
                  height={38}
                />
              </a>
            </li>
            <li>
              <a href={socials.facebook} target="_blank">
                <img
                  src={facebook}
                  alt="Facebook da Dimas construções"
                  width={39}
                  height={38}
                />
              </a>
            </li>
            <li>
              <a href={socials.instagram} target="_blank">
                <img
                  src={instagram}
                  alt="Instagram da Dimas construções"
                  width={39}
                  height={38}
                />
              </a>
            </li>
            <li>
              <a href={socials.linkedin} target="_blank">
                <img
                  src={linkedin}
                  alt="Instagram da Dimas construções"
                  width={39}
                  height={38}
                />
              </a>
            </li>
          </ul>
        </div>
      </footer>
    </>
  )
}

export default ReferralCampaign
